import DamagedCartPage from './DamagedCartPage';

export default DamagedCartPage;
